import {needAuth} from "../../instance/Instance";
import {AxiosError} from "axios";

async function getDisposeList(search, pageable) {
    console.log(">> 자산폐기관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return await needAuth.post('/lifecycle/dispose?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function getDisposeAssetList(search, pageable) {
    console.log(">> 폐기자산관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        if(pageable.sort === "createdAt"){
            sort += "disposeDate"
        }else{
            sort += pageable.sort
        }
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return await needAuth.post('/lifecycle/dispose/asset-list?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function removeDisposes(ids) {
    try {
        return await needAuth.put('/lifecycle/dispose/delete', ids);
    }catch (error){
        return error;
    }
}

async function getDispose(id) {
    try{
        return  await needAuth.get('/lifecycle/dispose/'+id);
    }catch (error){
        return error;
    }
}

async function saveDispose(dispose, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });
    
    formData.append(
        "disposeRequestDto",
        new Blob([JSON.stringify(dispose)], { type: "application/json" })
    );

    try {
        return await needAuth.post(`/lifecycle/dispose/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error;
    }
}

async function updateDispose(data) {
    try {
        return await needAuth.put(`/lifecycle/dispose/update`, data)
    }catch (error){
        return error;
    }
}

const updateDisposeForVerification = async (data) => {
    try {
        return await needAuth.put(`/lifecycle/dispose/verification`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const assetDispose = async (data) => {
    try {
        return await needAuth.post(`/lifecycle/dispose/asset`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export {getDisposeList, removeDisposes, saveDispose, getDispose, updateDispose, updateDisposeForVerification, assetDispose, getDisposeAssetList};